import React from 'react';

import Button from '~/components/button';
import { formatNumber } from '~/utils/numbers';

import styles from '~/components/modals/modal.module.scss';

const SeeWhy = ({ onCancel, smallLawnThreshold }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>Small lawn</h1>

    <p className={styles.text}>
      Our custom lawn plans are designed for{' '}
      <strong>
        lawns over {formatNumber(smallLawnThreshold, { round: true })} sq. ft
      </strong>{' '}
      for two key reasons:
    </p>

    <br />

    <p className={styles.text}>
      <strong className="highlight">Results:</strong> The nutrient load in
      Sunday pouches is too large for small lawns and risks over-fertilization.
    </p>

    <br />

    <p className={styles.text}>
      <strong className="highlight">Application:</strong> You would need to
      apply partial pouches, and at more frequent intervals than is outlined on
      your instructions.
    </p>

    <div className={styles.buttons}>
      <Button onClick={onCancel} variant="link" fullWidth>
        Go back
      </Button>
    </div>
  </div>
);

export default SeeWhy;
